/*
 * Authors: mariushirjanu
 * Created: 12/01/2024
 */
import { EVENT_TICKETDIALOG_SHOW, GA1Service, MESSAGE_TICKETGUIDE_SAVED } from '../../ga1/ga1.service';
import { ITicketGuideComponentInputs, TicketGuideComponent } from '../../../main/ticket-guide/ticket-guide.component';
import { Injectable } from '@angular/core';
import { DialogSize, GaMessageService, IDialog } from '../../message/ga-message.service';
import { IGAEvent } from '../ga-event.service';

@Injectable()
export class TicketGuideDialogService {
  constructor(
    private messageService:GaMessageService,
    private ga1Service:GA1Service
  ) {
    /**/
  }

  public activate():void {
    this.ga1Service.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_TICKETDIALOG_SHOW) {
        this.openTicketGuideDialog(event.data);
      }
    });
  }

  public openTicketGuideDialog(data:ITicketGuideComponentInputs):void {
    const ticketGuideDialog:IDialog = this.messageService.showDialog({
      wrapperComponent: false,
      component: TicketGuideComponent,
      inputs: {
        orderId: data?.orderId,
        webshopId: data?.webshopId,
        countryId: data?.countryId,
        workflowTypes: data?.workflowTypes,
        category: data?.category,
        hideGuideButtons: data?.hideGuideButtons,
        isInDialog: true
      },
      outputs: {
        onDialogClose: () => {
          this.ga1Service.sendMessage(MESSAGE_TICKETGUIDE_SAVED, {});
          ticketGuideDialog.hide();
        }
      },
      size: DialogSize.XL,
      closeButton: true,
      buttons: []
    });
  }
}